import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as l, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconChevronsRightLeft",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.354 3.146a.5.5 0 0 1 0 .708L8.207 6l2.147 2.146a.5.5 0 0 1-.708.708l-2.5-2.5a.5.5 0 0 1 0-.708l2.5-2.5a.5.5 0 0 1 .708 0Zm-8.708 0a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 1 1-.708-.708L3.793 6 1.646 3.854a.5.5 0 0 1 0-.708Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  _
];
function m(a, f, r, u, p, e) {
  return l(), i("svg", {
    "aria-label": r.ariaLabel,
    class: d([e.iconSizeClass, "d-icon d-icon--chevrons-right-left"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Chevrons Right Left",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, h, 10, c);
}
const C = /* @__PURE__ */ o(s, [["render", m]]);
export {
  C as default
};
//# sourceMappingURL=chevrons-right-left.js.map
